import { Component, inject } from '@angular/core';
import { ClipboardService } from 'app/core/services/clipboard.service';

@Component({
    selector: 'app-clipboard-feedback',
    template: `
        @if (clipboardService.feedback(); as feedback) {
            <div
                class="fixed bottom-4 left-4 right-4 z-50 flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-semibold text-white shadow-lg sm:bottom-6 sm:left-auto sm:right-6 sm:max-w-sm"
                [class.bg-green-700]="feedback.status === 'success'"
                [class.bg-red-700]="feedback.status === 'error'"
                [attr.role]="feedback.status === 'error' ? 'alert' : 'status'"
                [attr.aria-live]="feedback.status === 'error' ? 'assertive' : 'polite'"
                data-testid="clipboard-feedback"
            >
                @if (feedback.status === 'success') {
                    <svg aria-hidden="true" class="size-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                } @else {
                    <svg aria-hidden="true" class="size-5 shrink-0" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                    </svg>
                }

                <span>{{ feedback.message }}</span>

                <button
                    type="button"
                    class="-mr-1 ml-1 rounded p-1 text-white/80 hover:bg-white/10 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                    aria-label="Dismiss clipboard notification"
                    (click)="clipboardService.dismiss()"
                >
                    <svg aria-hidden="true" class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        }
    `
})
export class ClipboardFeedbackComponent {
    readonly clipboardService = inject(ClipboardService);
}
